<h2 class="page-title" mat-dialog-title>Log Details</h2>
<mat-dialog-content class="mat-dialog-content-no-heading">
  <table class="details-wrapper">
    <tbody>
      <tr>
        <td class="call-details-content">
          <h5>Date/Time:</h5>
          <div class="detail-item">{{ callLogs.createUserDate | date : 'MM/dd/yyyy hh:mm:ss aa' }}</div>
        </td>
        <td>
          <h5>Severity:</h5>
          <div class="detail-item">{{ callLogs.severityId }}</div>
        </td>
      </tr>
      <tr>
        <td>
          <h5>Type:</h5>
          <div class="detail-item">{{ callLogs.typeId }}</div>
        </td>
        <td>
          <h5>Area:</h5>
          <div class="detail-item">{{ callLogs.areaId }}</div>
        </td>
      </tr>
      <tr>
        <td class="call-details-content" colspan="2">
          <h5>Message:</h5>
          <div class="detail-item">
            {{ callLogs.message }}
          </div>
        </td>
      </tr>
      <tr>
        @if (callLogs.account) {
          <td class="call-details-content">
            <h5>Account:</h5>
            <div class="detail-item">
              <a [routerLink]="getRouterLink(callLogs.account.accountId)" (click)="onCloseClick()">
                {{ callLogs.account.name }}
              </a>
            </div>
          </td>
        }
      </tr>
      <tr>
        @if (callLogs.logCode === LogCodes.ARIConnection) {
          <td class="call-details-content">
            <button
              class="add-right-margin detail-item"
              type="button"
              mat-stroked-button
              color="primary"
              (click)="openLink(callLogs)"
              tabindex="-1"
              >
              Graylog
            </button>
          </td>
        }
      </tr>
    </tbody>
  </table>
</mat-dialog-content>
<mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onCloseClick()">Close</button>
</mat-dialog-actions>
